module.exports = __webpack_public_path__ + "img/pbb.bc4ba29b.png";